/**
 * 标题部分显示控制 - 根据占位符即将进入视口来切换标题部分的显示/隐藏
 * 需要 HTML 结构：
 * - .section-title01-placeholder, .section-title02-placeholder 等占位符元素
 * - .section-title01, .section-title02 等标题元素（包含在 .d20-air-plus-title-section 内）
 */
function setupTitleSectionObserver() {
  // 配置占位符和对应标题的映射
  const titleConfigs = [
    { placeholder: '.section-title01-placeholder', title: '.section-title01' },
    { placeholder: '.section-title02-placeholder', title: '.section-title02' },
    { placeholder: '.section-title03-placeholder', title: '.section-title03' },
    { placeholder: '.section-title04-placeholder', title: '.section-title04' }
  ];

  // 获取所有 .d20-air-plus-title-section 元素
  const allTitleSections = document.querySelectorAll('.d20-air-plus-title-section');
  
  // 初始状态：全部隐藏
  allTitleSections.forEach(section => {
    section.style.display = 'none';
  });

  // 创建 Intersection Observer 来监听占位符，设置提前100%进入
  const observerOptions = {
    root: null,
    rootMargin: '100% 0px 0px 0px',  // 顶部提前100%触发
    threshold: 0  // 只要有1px即将进入就触发
  };

  const observer = new IntersectionObserver((entries) => {
    // 先检查是否有任何占位符是可见的（或即将可见）
    let activePlaceholderIndex = -1;
    let earliestEntryTime = Infinity;
    
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 找到这个占位符对应的配置索引
        const configIndex = titleConfigs.findIndex(cfg => 
          entry.target.classList.contains(cfg.placeholder.slice(1))
        );
        
        if (configIndex !== -1) {
          // 记录触发时间，用于找到最早进入的占位符
          if (entry.time < earliestEntryTime) {
            earliestEntryTime = entry.time;
            activePlaceholderIndex = configIndex;
          }
        }
      }
    });

    // 获取所有占位符的位置信息，用于调试
    const allPlaceholders = titleConfigs.map((config, index) => {
      const el = document.querySelector(config.placeholder);
      if (el) {
        const rect = el.getBoundingClientRect();
        return {
          index: index + 1,
          distanceFromViewport: rect.top,
          isVisible: rect.top < window.innerHeight + 300 && rect.bottom > -300
        };
      }
      return null;
    });

    // console.log('📍 Placeholder distances:', allPlaceholders.filter(p => p));
    // console.log('📍 Active placeholder:', activePlaceholderIndex !== -1 ? activePlaceholderIndex + 1 : 'none');

    // 隐藏所有标题部分
    allTitleSections.forEach(section => {
      section.style.display = 'none';
    });

    // 如果找到了活动的占位符，显示对应的标题
    if (activePlaceholderIndex !== -1) {
      const config = titleConfigs[activePlaceholderIndex];
      const titleElement = document.querySelector(config.title);
      
      if (titleElement) {
        const parentSection = titleElement.closest('.d20-air-plus-title-section');
        if (parentSection) {
          parentSection.style.display = 'block';
          console.log('✨ Showing title section:', activePlaceholderIndex + 1, '-', config.title);
        }
      }
    } else {
      console.log('💤 All title sections hidden');
    }
  }, observerOptions);

  // 观察所有占位符元素
  titleConfigs.forEach((config, index) => {
    const placeholder = document.querySelector(config.placeholder);
    if (placeholder) {
      observer.observe(placeholder);
      console.log('👁️ Observing placeholder', index + 1 + ':', config.placeholder);
    } else {
      console.warn('⚠️ Placeholder not found:', config.placeholder);
    }
  });

  // 添加滚动事件监听，用于调试（可选）
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    
    // 计算每个占位符的位置
    titleConfigs.forEach((config, index) => {
      const placeholder = document.querySelector(config.placeholder);
      if (placeholder) {
        const rect = placeholder.getBoundingClientRect();
        const distanceFromTop = rect.top;
        const isWithinTriggerZone = distanceFromTop <= 300 && distanceFromTop > -viewportHeight;
        
        if (isWithinTriggerZone) {
          console.debug(`Placeholder ${index + 1} is ${Math.round(distanceFromTop)}px from viewport top`);
        }
      }
    });
  }, { passive: true });

  return { 
    observer, 
    destroy: () => {
      observer.disconnect();
      window.removeEventListener('scroll', scrollHandler);
    }
  };
}



/**
 * .d20-air-plus-2in1-info 进入视口后添加active类
 * 当有active类时，.item::after 的宽度从0变为100%
 */
function setup2in1InfoAnimationRepeating() {
  const targetElements = document.querySelectorAll('.d20-air-plus-2in1-info');
  
  if (targetElements.length === 0) {
    return;
  }

  // 为每个元素创建独立的Observer
  targetElements.forEach((element, index) => {
    // 创建Intersection Observer
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素进入视口，添加active类
          element.classList.add('active');
        } else {
          // 元素离开视口，移除active类
          element.classList.remove('active');
        }
      });
    }, observerOptions);

    // 开始观察当前元素
    observer.observe(element);
    
    // 将observer存储在元素上，方便后续清理
    element._observer = observer;

  });

  // 返回清理函数
  return {
    destroy: () => {
      targetElements.forEach(element => {
        if (element._observer) {
          element._observer.disconnect();
          delete element._observer;
        }
      });
    }
  };
}


// 初始化
document.addEventListener('DOMContentLoaded', function() {
  // 标题部分显示控制
  setupTitleSectionObserver();

  // 多个section含有.d20-air-plus-2in1-info
  setup2in1InfoAnimationRepeating();
});




